import React, { useEffect, useMemo, useState } from "react";
import { ChatCommonPage } from "../../../commonPage";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../../redux/actions";
import { PiDotsThreeOutlineVertical } from "react-icons/pi";
import { LuFileSearch2 } from "react-icons/lu";
import { useTranslation } from "react-i18next";
import { Badges, DropDown } from "../../../components";
import { useNavigate } from "react-router-dom";

const CancelledChats = ({ loginData }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [search, setSearch] = useState("");
    const [dateRange, setDateRange] = useState([null, null]);
    const [filteredChatsList, setFilteredChatsList] = useState([]);

    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };

    useEffect(() => {
        dispatch(
            actionPatient.postGetChatAppointmentByPatient({
                RequestTimeZone: loginData.timeZoneId,
                currency: 'EUR',
                languageId: loginData?.languageId,
                patientGuid: loginData?.userGuid,
            })
        );
    }, [dispatch, loginData?.languageId, loginData.timeZoneId, loginData?.userGuid]);
    const postGetChatAppointmentByPatientData = useSelector(
        (state) => state.patient.postGetChatAppointmentByPatientData?.data
    );

    const filteredChats = useMemo(
        () =>
            postGetChatAppointmentByPatientData?.result?.filter(
                (item) => item.status === 5
            ) || [],
        [postGetChatAppointmentByPatientData]
    );
    useEffect(() => {
        setFilteredChatsList(filteredChats);
    }, [filteredChats]);
    // const handleSelect = (id, chat) => {
    //     if (id === "create-invoice") {
    //         navigate(`/doctor/generate-invoice/${chat?.appointmentGuid}`, {
    //             state: { appointment: chat },
    //         });
    //     } else if (id === "view-invoice") {
    //         if (chat?.pdfUrl) {
    //             window.open(chat.pdfUrl, "_blank");
    //         }
    //     } else if (id === "view-chat") {
    //         navigate(`/doctor/chat-with-patient/${chat?.appointmentGuid}`, {
    //             state: { chat },
    //         });
    //     }
    // };
    const onSearchClick = () => {
        const startDate = new Date(dateRange[0]).setHours(0, 0, 0, 0);
        const endDate = new Date(dateRange[1]).setHours(23, 59, 59, 999);

        const filteredData = filteredChats.filter((chat) => {
            const appointmentDate = new Date(chat.appointmentDateTime).getTime();
            const isWithinDateRange =
                appointmentDate >= startDate && appointmentDate <= endDate;

            const searchQuery = search.toLowerCase();
            const matchesSearch =
                chat.chatBookingId.toString().includes(searchQuery) ||
                chat.patientName.toLowerCase().includes(searchQuery) ||
                chat.medicalSpeciality.toLowerCase().includes(searchQuery);

            return isWithinDateRange || matchesSearch;
        });

        setFilteredChatsList(filteredData);
    };

    return (
        <ChatCommonPage
            pageHeading={t("chatPage.Cancelled.pageHeading")}
            loginData={loginData}
            chatTableHeading={t("chatPage.Cancelled.chatTableHeading")}
            chatTableColumns={[
                `${t("booking_id")}`,
                `${t("doctor_name")}`,
                `${t("medical_specialty")}`,
                `${t("time_&_date")}`,


                'EUR',
                "",
            ]}
            chatTableData={filteredChatsList?.map((chat, index) => ({
                [t("booking_id")]: chat.chatBookingId,
                [t("doctor_name")]: chat.doctorName,
                [t("medical_specialty")]: chat.medicalSpeciality,
                [t("time_&_date")]: (
                    <>
                        <div>
                            {new Date(chat.appointmentDateTime).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })}
                        </div>
                        <div>
                            {new Date(chat.appointmentDateTime)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, " - ")}
                        </div>
                    </>
                ),

                'EUR': chat.chatFees,
                "": (
                    <DropDown.DropDown
                        className="moreaction-dropdown"
                        drpDwnText={<PiDotsThreeOutlineVertical className="moreAction" />}
                        drpItems={[
                            {
                                id: "create-invoice",
                                label: t("create_invoice"),
                            },
                            chat?.pdfUrl && {
                                id: "view-invoice",
                                label: t("view_invoice"),
                            },
                            {
                                id: "view-chat",
                                label: t("view_chat"),
                            },
                        ]}
                    // onSelect={(id) => handleSelect(id, chat)}
                    />
                ),
            }))}
            className="doctor-chats-completed"
            onSearchClick={onSearchClick}
            dateRange={dateRange}
            searchValue={search}
            handleDateRangeChange={handleDateRangeChange}
            onSearchChange={(e) => setSearch(e.target.value)}
        />
    );
};

export default CancelledChats;

